import React, { useRef, useEffect } from "react";
import Container from "../../UI/Container/Container";
import classes from "./Intro.module.css";
import oldWestImg from "../../../assets/images/old-west.jpg";
import { gsap } from "gsap";

const Intro = (props) => {

  const contentRef = useRef(null)

  useEffect(()=>{
    const timeline = gsap.timeline()

    timeline.to(contentRef.current, {opacity:1, duration: 1, delay:1.25, ease:'sine.out'})
  })

  return (
    <div className={classes.Intro}>
      <div className={classes.IntroBg}>
        <img src={oldWestImg} alt="Aerial shot of Old West" />
      </div>
      <div ref={contentRef} className={classes.Content}>
        <Container>
          <h1>Our Identity</h1>
        </Container>
      </div>
    </div>
  );
};

export default Intro;
